import {IKnockoutComponent} from "../../../../index";
import {DynamicProperties} from "./DynamicProperties";
import {ObjectTypeId} from "../../../../constants";

interface ITypeComponentParams extends IKnockoutComponent {
    params: ITypeParams
}

interface ITypeParams {
    dynamicProperties: DynamicProperties
}

interface IMutableSyncfieldParameters {
    name: string
    displayname: string
    parameter: string
    val: KnockoutObservable<any>
    objectTypeId: KnockoutComputed<ObjectTypeId>
    objectTypeIds: KnockoutComputed<ObjectTypeId[]>
}

type TParameterType = 'static' | 'boolean' | 'syncfield-id' | 'text' | 'textarea' | 'date';

type TState = 'waiting' | 'loading' | 'ready' | 'error';